export const clinicalNotesQueryKeys = [
  'clinicalNotes',
  'overview-clinical-notes',
  'clinicalNotesInfinite',
  'checkPatientNotes'
];

export const overviewLedgerQueryKeys = ['overview-ledger', 'overview-balance-ledger'];

export const MESSAGES_COUNT_QUERY_KEY = 'messagesCount';

export const COMMUNICATION_LOGS_QUERY_KEY = 'communication_logs';

export const WIZARD_TEMPLATE_QUERY_KEY = 'wizard-template';

export const refundReasonsQueryKey = 'refund-reasons';
